export enum RestaurantsDisabledReasonEnum {
  OVER_LIMIT = 'over limit'
}
